// extracted by mini-css-extract-plugin
export default {"container":"LabelBenchmarkIcon_container__w75HY","columnDataBenchmarkLabel":"LabelBenchmarkIcon_columnDataBenchmarkLabel__dOBFv"};